module.exports = __webpack_public_path__ + "static/img/device.ed1ab10b.png";